import { MODEL_TYPE_NAMES } from '../../../AppProviders/PrinterProvider'
import { usePrinter } from '../../../hooks/usePrinter'
import useTranslations from '../../../i18n/useTranslations'
import { ReactComponent as PrintLabelFirstPosition } from '../../../assets/images/print-label-first-position.svg'
import { ReactComponent as PrintLabelSecondPosition } from '../../../assets/images/print-label-second-position.svg'
import { ReactComponent as PrintLabelThirdPosition } from '../../../assets/images/print-label-third-position.svg'
import { ReactComponent as PrintLabelFourthPosition } from '../../../assets/images/print-label-fourth-position.svg'
import { ReactComponent as PrintLabel3FirstPosition } from '../../../assets/images/print-3-labels-first-position.svg'
import { ReactComponent as PrintLabel3SecondPosition } from '../../../assets/images/print-3-labels-second-position.svg'
import { ReactComponent as PrintLabel3ThirdPosition } from '../../../assets/images/print-3-labels-third-position.svg'

import PrintModalView from './View'

const PrintModal = props => {
  const t = useTranslations()
  const { modelType } = usePrinter()

  const options =
    modelType === MODEL_TYPE_NAMES.multi3
      ? [
          {
            value: 1,
            label: t('print-modal:first-position'),
            preview: <PrintLabel3FirstPosition />,
          },
          {
            value: 2,
            label: t('print-modal:second-position'),
            preview: <PrintLabel3SecondPosition />,
          },
          {
            value: 3,
            label: t('print-modal:third-position'),
            preview: <PrintLabel3ThirdPosition />,
          },
        ]
      : [
          {
            value: 1,
            label: t('print-modal:first-position'),
            preview: <PrintLabelFirstPosition />,
          },
          {
            value: 2,
            label: t('print-modal:second-position'),
            preview: <PrintLabelSecondPosition />,
          },
          {
            value: 3,
            label: t('print-modal:third-position'),
            preview: <PrintLabelThirdPosition />,
          },
          {
            value: 4,
            label: t('print-modal:fourth-position'),
            preview: <PrintLabelFourthPosition />,
          },
        ]

  return <PrintModalView {...props} options={options} />
}

PrintModal.propTypes = PrintModalView.propTypes

export default PrintModal
